import { LogoutOutlined } from '@ant-design/icons';
import { RuntimeConfig } from '@umijs/max';
import { Dropdown } from 'antd';

// Load Tawk.to script when app renders
export function render(oldRender: () => void) {
  // Check if Tawk.to is already loaded to avoid duplicate loading
  if (!(window as any).Tawk_API) {
    (window as any).Tawk_API = (window as any).Tawk_API || {};
    (window as any).Tawk_LoadStart = new Date();

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://embed.tawk.to/68601213056789190faddc0c/1iurkd7gs';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');

    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
  }

  oldRender();
}

// Global initial state configuration
export async function getInitialState(): Promise<{ name: string }> {
  return { name: 'trythis' };
}

export const layout: RuntimeConfig = () => {
  return {
    logo: 'https://img.alicdn.com/tfs/TB1YHEpwUT1gK0jSZFhXXaAtVXa-28-27.svg',
    menu: {
      locale: true,
    },
    layout: 'top',
    avatarProps: {
      src: 'https://gw.alipayobjects.com/zos/antfincdn/efFD%24IOql2/weixintupian_20170331104822.jpg',
      size: 'small',
      shape: 'circle',
      render: (_, dom) => {
        return (
          <Dropdown
            menu={{
              items: [
                {
                  key: 'logout',
                  icon: <LogoutOutlined />,
                  label: 'Logout',
                },
              ],
            }}
          >
            {dom}
          </Dropdown>
        );
      },
    },
  };
};